import React, { Component, useEffect } from "react";
import { FormValidate } from "../../../../components/formValidate";
import CustomButton from "../../../../components/inputs/button";
import DatePickerField from "../../../../components/inputs/datepicker";
import TextField from "../../../../components/inputs/textfield";
import Snackbar from "../../../../components/snackbar/snackbar";

import Loader from "../../../../components/loader/loader";
import { admin_news_add, admin_news_edit } from "../../admin.api";
import "./dialog.css";
import RichTextEditor, { Quill } from "@mantine/rte";

let required = ["title", "description", "title_ma", "description_ma"];
const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);
let refreshKey = 1;

const FONT_FAMILIES = [
  { label: "Default", value: "" },
  { label: "Arial", value: "Arial, sans-serif" },
  { label: "Georgia", value: "Georgia, serif" },
  { label: "Times New Roman", value: "'Times New Roman', serif" },
  { label: "Courier New", value: "'Courier New', monospace" },
  { label: "Roboto", value: "Roboto, sans-serif" },
];

const FONT_SIZE_OPTIONS = [
  { label: "12", value: "12px" },
  { label: "14", value: "14px" },
  { label: "16", value: "16px" },
  { label: "18", value: "18px" },
  { label: "20", value: "20px" },
  { label: "24", value: "24px" },
];

const FONT_WHITELIST = FONT_FAMILIES.map((item) => item.value).filter(Boolean);
FONT_WHITELIST.unshift("sans-serif", "serif", "monospace");

const SIZE_WHITELIST = FONT_SIZE_OPTIONS.map((item) => item.value);

if (typeof window !== "undefined") {
  const Font = Quill.import("formats/font");
  Font.whitelist = FONT_WHITELIST;
  Quill.register(Font, true);

  const Size = Quill.import("attributors/style/size");
  Size.whitelist = SIZE_WHITELIST;
  Quill.register(Size, true);
}

const RTE_MODULES = {
  toolbar: [
    [{ font: FONT_WHITELIST }],
    [{ size: SIZE_WHITELIST }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link", "image", "video"],
    ["code-block", "blockquote"],
    ["clean"],
  ],
  clipboard: { matchVisual: false },
};

const RTE_FORMATS = [
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "header",
  "list",
  "bullet",
  "align",
  "link",
  "image",
  "video",
  "code-block",
  "blockquote",
];

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData,
      edit: props.edit,
      isActive: false,
      submitted: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
      fileError: false,
      fileChange: false,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
    });
  };
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };
  handleDueDateChange = (e) => {
    const date = e?.value || null;
    this.setState({
      formData: {
        ...this.state.formData,
        due_date: date,
      },
    });
  };
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const sizeInMB = file.size / (1024 * 1024);
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (fileExtension === "pdf" && sizeInMB <= 5) {
      this.setState({
        fileError: false,
        formData: {
          ...this.state.formData,
          file: file,
          file_name: file.name,
        },
      });
    } else {
      this.setState({
        fileError: true,
        formData: {
          ...this.state.formData,
          file: null,
          file_name: null,
        },
        isSnackError: true,
        snackOpen: true,
        snackMessage: "Only PDF files up to 5MB are allowed.",
      });

      // Reset input value so user can re-upload same file
      e.target.value = null;
    }
  };

  handleRichChange = (name, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
    });
  };
  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };
  handleDatePickerChange = (e, value) => {
    let date = e.value;
    if (date) {
      this.setState({
        formData: {
          ...this.state.formData,
          notification_date: date,
        },
      });
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          notification_date: null,
        },
      });
    }
  };
  handleSubmit = (e) => {
    const error = FormValidate(this.state.formData, required);
    const { edit, formData, snackMessage, isSnackError, snackOpen, isActive } =
      this.state;
    e.preventDefault();
    if (
      !formData?.description ||
      formData?.description.trim() === "" ||
      formData?.description === "<p><br></p>" ||
      !formData?.description_ma ||
      formData?.description_ma.trim() === "" ||
      formData?.description_ma === "<p><br></p>"
    ) {
      this.setState({
        snackMessage: "Description in English and Malayalam is required.",
        isSnackError: true,
        snackOpen: true,
        isActive: false,
      });
      return;
    }

    // Normalize payload (especially due_date)
    const normalized = { ...formData };
    if (normalized?.due_date) {
      const raw = normalized.due_date;
      // Accept Date object, ISO string, or DD-MM-YYYY
      let isoDate = null;
      if (raw instanceof Date && !isNaN(raw)) {
        isoDate = raw.toISOString().slice(0, 10);
      } else if (typeof raw === "string") {
        // Try parse DD-MM-YYYY
        const ddmmyyyy = raw.match(/^([0-3]?\d)-([0-1]?\d)-(\d{4})$/);
        if (ddmmyyyy) {
          const [, dd, mm, yyyy] = ddmmyyyy;
          isoDate = `${yyyy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
        } else {
          const d = new Date(raw);
          if (!isNaN(d)) isoDate = d.toISOString().slice(0, 10);
        }
      }
      if (isoDate) normalized.due_date = isoDate;
    }

    let payload = new FormData();
    Object.keys(normalized).forEach((key) => {
      if (key === "news_enable_disable") return; // deprecated, do not send
      if (key === "status") {
      } else if (key === "file" && typeof formData?.file != "string") {
        payload.append("file", formData?.file);
      } else if (key !== "status" && key !== "file") {
        payload.append(key, normalized[key] ?? "");
      }
    });
    if (Object.keys(error).length === 0) {
      this.setState({ isActive: true });
      if (edit) {
        admin_news_edit(formData?.id, payload)
          .then((res) => {
            this.setState({
              submitted: true,
              isActive: false,
              snackMessage: res.message,
              isSnackError: false,
              snackOpen: true,
            });
          })
          .catch((error) => {
            this.setState({
              submitted: false,
              snackMessage: error.message,
              isActive: false,
              isSnackError: true,
              snackOpen: true,
            });
          });
      } else {
        admin_news_add(payload)
          .then((res) => {
            this.setState({
              submitted: true,
              isActive: false,
              snackMessage: res.message,
              isSnackError: false,
              snackOpen: true,
            });
          })
          .catch((error) => {
            this.setState({
              submitted: false,
              isActive: false,
              snackMessage: error.message,
              isSnackError: true,
              snackOpen: true,
            });
          });
      }
    } else {
      this.setState({
        submitted: false,
        snackMessage: "Please fill all mandatory fields",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };

  render() {
    const { submitted, formData, open, edit, isActive } = this.state;
    const { view } = this.props;

    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <Loader open={isActive} />
            <div className="overlay">
              <div className="big-dia-scroll dialog" style={{ height: '80vh', width: '50vw', overflowY: 'auto' }}>
                <Snackbar
                  message={this.state.snackMessage}
                  error={this.state.isSnackError}
                  open={this.state.snackOpen}
                  close={this.snackbarClose}
                />
                <div className=" d-flex flex-column justify-content-between h-100">
                  <div >
                  <div className="flexDisplay">
                    <div className="diaTitleCon">
                      {edit
                        ? "Edit News and Updates"
                        : view
                        ? "News and Updates"
                        : "Create News and Updates"}
                    </div>
                    <div className="dia-close" onClick={this.props.handleClose}>
                      <div className="diaCloseCon">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div>
                  </div>
                  <div className="tilebar d-flex justify-content-start">
                    <hr />
                  </div>
                  </div>
                  <div style={{ overflowY: "auto" }}>
                  <form action="" >
                    <div className="row book-form" style={{width : "100%"}}>
                      <div className="">
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Title[Eng]"
                            variant="outlined"
                            maxLength={170}
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData?.title ?? ""}
                            name="title"
                            required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Title[Mal]"
                            variant="outlined"
                            maxLength={170}
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData?.title_ma ?? ""}
                            name="title_ma"
                            required
                          />
                        </div>
                        <div className="col-12">
                          <div className="mylabel">Description[Eng]</div>
                          <RichTextEditor
                            value={this.state.formData?.description ?? ""}
                            key={this.state.refreshKey}
                            name="description"
                            label="Description[English]"
                            modules={view ? { toolbar: false } : RTE_MODULES}
                            formats={RTE_FORMATS}
                            onChange={(value) =>
                              this.handleRichChange("description", value)
                            }
                            styles={{
                              blockquote: {
                                color: "red",
                                display: "inline-block",
                              },
                            }}
                            required
                          />
                        </div>
                        <div className="col-12">
                          <div className="mylabel">Description[Mal]</div>
                          <RichTextEditor
                            value={this.state.formData?.description_ma ?? ""}
                            key={this.state.refreshKey}
                            name="description_ma"
                            label="Description[Malayalam]"
                            modules={view ? { toolbar: false } : RTE_MODULES}
                            formats={RTE_FORMATS}
                            onChange={(value) =>
                              this.handleRichChange("description_ma", value)
                            }
                            styles={{
                              blockquote: {
                                color: "red",
                                display: "inline-block",
                              },
                            }}
                            required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Link"
                            name="link"
                            variant="outlined"
                            disabled={view}
                            value={formData?.link ?? ""}
                            onChange={(e) => this.handleChange(e)}
                            // required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            type="file"
                            // view="straight"
                            id="outlined-basic"
                            onChange={(e) => this.handleFileChange(e)}
                            label="File"
                            disabled={view}
                            fileName={formData?.file_name}
                            accept=".pdf,.docx,.doc"
                            // required
                          />
                          {this.state.fileError && (
                            <div className="file-up-helper text-start">
                              *Upload only .pdf and Size should be less than 5MB
                            </div>
                          )}
                        </div>
                        <div className="col-12">
                          <DatePickerField
                            id="due-date"
                            label="Due Date"
                            name="due_date"
                            disabled={view}
                            value={formData?.due_date ? new Date(formData.due_date) : null}
                            onChange={this.handleDueDateChange}
                          />
                        </div>
                      </div>
                     
                    </div>
                  </form>
                  </div>
                  <div>
                   {!view && (
                        <div className="col-12">
                          <CustomButton
                            label={edit ? "Update News" : "Create News"}
                            disabled={submitted}
                            onClick={(e) => this.handleSubmit(e)}
                          />
                        </div>
                      )}
                      </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
